import { createStore, applyMiddleware} from 'redux';
import reducers from './reducers/_index';
import cache from './cache';
import {pluck} from '../utils';

export default class Store {
	constructor(client_id, profile_id) {
        this.profile_id = profile_id;
        this.client_id = client_id;

        const initialData = cache.getInitialData(profile_id);
        if(initialData){
            this.store = createStore(reducers, initialData, applyMiddleware(cache.middleware.bind(this)));
        }else{
            this.store = createStore(reducers, applyMiddleware(cache.middleware.bind(this)));
        }
        
        this.subscribe = this.store.subscribe;
        this.getState = this.store.getState;
        this.dispatch = this.store.dispatch;
    }   
    get(path){
        if(!path){
            let state = this.getState();
            
            let response = {
                client_id: this.client_id,
                loading: false
            };
            for(let key of Object.keys(state)){
                if(key !== 'action'){
                    response[key] = state[key];
                    if(state[key].loading){
                        response.loading = true;
                    }
                }
            }

            return response
        }

        try{
            let response = pluck(this.store.getState(), path);
            return response
        }catch(e){
            return null
        }
    }
}